import store from 'store'

import { getToken } from './localStorage'

type StateWithAuthToken = { auth?: { token?: string } }

/** Bearer do Line: localStorage (API) ou Redux (ex.: após rehydrate do persist). */
export function getLineBearerToken (): string | undefined {
  const ls = getToken()
  if (ls) return ls
  try {
    const r = (store.getState() as StateWithAuthToken).auth?.token
    if (r && String(r).length > 0) return String(r)
  } catch {
    /* store ainda não disponível */
  }
  return undefined
}
